import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SocialButtons from './components/SocialButtons';
import LanguageSync from './components/LanguageSync';
import Home from './pages/Home';
import Services from './pages/Services';
import VivreEnEspagne from './pages/VivreEnEspagne';
import ReconnaissanceDiplomes from './pages/ReconnaissanceDiplomes';
import DocumentsDemarches from './pages/DocumentsDemarches';
import Diagnostic from './pages/Diagnostic';
import Collaborateurs from './pages/Collaborateurs';
import Temoignages from './pages/Temoignages';
import Paiement from './pages/Paiement';
import ConsultoriaMarruecosES from './pages/ConsultoriaMarruecosES';

function App() {
  return (
    <Router>
      <div className="App">
        <LanguageSync />
        <Navbar />
        <SocialButtons />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nos-services" element={<Services />} />
          <Route path="/vivre-en-espagne" element={<VivreEnEspagne />} />
          <Route path="/reconnaissance-des-diplomes" element={<ReconnaissanceDiplomes />} />
          <Route path="/documents-demarches" element={<DocumentsDemarches />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/collaborateurs" element={<Collaborateurs />} />
          <Route path="/temoignages" element={<Temoignages />} />
          <Route path="/paiement" element={<Paiement />} />
          <Route path="/consultoria-marruecos" element={<ConsultoriaMarruecosES />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
